import React from "react";

import SvgIcon from "@mui/material/SvgIcon";
import ChevronRight from "@mui/icons-material/ChevronRight";

const LookMainFeatureGroupsExpandIcon = () => {

  return (
    <div className="lm-parent__expand">
      <SvgIcon>
        <ChevronRight/>
      </SvgIcon>
    </div>
  )
};

export default LookMainFeatureGroupsExpandIcon
